import React, { useState, useEffect } from "react";
import { slide as Menu } from "react-burger-menu";
import { Link as RouterLink } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";
import logobeta from "../../img/hobbestie_beta.png";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import "./Navbar.css";

const Navbar = () => {
  const [active, setActive] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const isSamePage = location.pathname === "/";

  const handleLogoClick = () => {
    navigate("/", { replace: true });
  };

  useEffect(() => {
    const updateScreenSize = () => {
      setActive(window.innerWidth > 768);
    };
    updateScreenSize();
    window.addEventListener("resize", updateScreenSize);
    return () => window.removeEventListener("resize", updateScreenSize);
  }, []);

  const closeMenu = () => setMenuOpen(false);

  return (
    <div className="n-wrapper">
      {/* Left Section - Logo */}
      <ScrollLink to="Title" smooth duration={500}>
        <div className="n-left" onClick={handleLogoClick}>
          <img src={logobeta} alt="hobbestie Logo Beta" />
        </div>
      </ScrollLink>
      {/* Right Section - Navigation */}
      <div className="n-right">
        {active ? (
          <div className="n-list">
            <ul>
              <li>
                {isSamePage ? (
                  <ScrollLink to="Features" smooth activeClass="activeClass">
                    Features
                  </ScrollLink>
                ) : (
                  <RouterLink
                    to="/"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/");
                      setTimeout(() => {
                        document
                          .getElementById("Features")
                          ?.scrollIntoView({ behavior: "smooth" });
                      }, 500);
                    }}
                  >
                    Features
                  </RouterLink>
                )}
              </li>
              <li>
                {isSamePage ? (
                  <ScrollLink to="Hobbies" smooth activeClass="activeClass">
                    Hobbies
                  </ScrollLink>
                ) : (
                  <RouterLink
                    to="/"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/");
                      setTimeout(() => {
                        document
                          .getElementById("Hobbies")
                          ?.scrollIntoView({ behavior: "smooth" });
                      }, 500);
                    }}
                  >
                    Hobbies
                  </RouterLink>
                )}
              </li>

              <li>
                <RouterLink to="/pricing">Pricing</RouterLink>
              </li>

              <li>
                <a
                  href="https://hobbestie.app/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="button n-button">Sign Up</button>
                </a>
              </li>
            </ul>
          </div>
        ) : (
          <Menu
            right
            width={"100%"}
            height={"100%"}
            isOpen={menuOpen}
            onStateChange={({ isOpen }) => setMenuOpen(isOpen)}
            menuClassName={menuOpen ? "bm-menu-open" : ""}
          >
            <button className="close-btn" onClick={closeMenu}>
              ✖
            </button>
            <div className="burger-logo">
              <img src={logobeta} alt="hobbestie Logo Beta" />
            </div>
            <RouterLink
              to="/"
              onClick={(e) => {
                e.preventDefault();
                closeMenu();
                navigate("/");
                setTimeout(() => {
                  document
                    .getElementById("Features")
                    ?.scrollIntoView({ behavior: "smooth" });
                }, 500);
              }}
            >
              Features
            </RouterLink>
            <RouterLink
              to="/"
              onClick={(e) => {
                e.preventDefault();
                closeMenu();
                navigate("/");
                setTimeout(() => {
                  document
                    .getElementById("Hobbies")
                    ?.scrollIntoView({ behavior: "smooth" });
                }, 500);
              }}
            >
              Hobbies
            </RouterLink>
            <RouterLink
              to="/"
              onClick={(e) => {
                e.preventDefault();
                closeMenu();
                navigate("Pricing");
                setTimeout(() => {
                  document
                    .getElementById("Pricing")
                    ?.scrollIntoView({ behavior: "smooth" });
                }, 500);
              }}
            >
              Pricing
            </RouterLink>
            <li>
              <a
                href="https://hobbestie.app/"
                target="_blank"
                rel="noopener noreferrer"
                className="burger-login"
                onClick={closeMenu}
              >
                Login
              </a>
            </li>
          </Menu>
        )}
      </div>
    </div>
  );
};

export default Navbar;
